module.exports = __webpack_public_path__ + "img/share-bg-18.49f29734.jpg";